import { Box } from '@mui/material';
import SearchTour from '../container/SearchTour';

export default function SearchTourPage() {
  return (
    <Box maxWidth="1400px" margin="auto">
      <SearchTour />
    </Box>
  );
}
